import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import BookingOnline from "./Frontend/MainLayout/BookingOnline/BookingOnline";
import Contact from "./Frontend/MainLayout/Contact/Contact";
import Home from "./Frontend/MainLayout/Homepage/Home";
import Relaxation from "./Frontend/MainLayout/Relaxation/Relaxation";
import AllRooms from "./Frontend/MainLayout/Rooms/AllRooms";
import Restaurentssingle from "./Frontend/MainLayout/SinglePageRoom/Restaurentssingle";
import Footer from "./Frontend/Shared/Footer/Footer";
import Header from "./Frontend/Shared/Header/Header";
// import loaderImg from "./Assets/Infinity-1.4s-200px.gif";
import Gallery from "./Frontend/Gallery/Gallery";
import AOS from "aos";
import "aos/dist/aos.css";
import MeetingAndEvents from "./Frontend/MainLayout/MeetingAndEvents/MeetingAndEvents";
import ScrollToTop from "react-scroll-to-top";
import PremiumSuite from "./Frontend/MainLayout/SinglePageRoom/PremiumSuite";
import SpecialOffers from "./Frontend/Sepcial_offers/SpecialOffers";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { ToastContainer } from "react-toastify";
import SwimmingPool from "./Frontend/MainLayout/SwimmingPool/SwimmingPool";
import Playzone from "./Frontend/MainLayout/Playzone/Playzone";
import Kidzone from "./Frontend/MainLayout/Kidzone/Kidzone";
import Recreation from "./Frontend/MainLayout/Recreation/Recreation";
import Facilities from "./Frontend/MainLayout/Facilities/Facilities";
import NotFound from "./Frontend/MainLayout/NotFound/NotFound";
import Deluxe from "./Frontend/MainLayout/SinglePageRoom/Deluxe";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  AOS.init();

  const location = useLocation();

  useEffect(() => {
    // Scroll top when location changes
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <ToastContainer />
      <Header></Header>

      <ScrollToTop smooth color="#6f00ff" className="px-2" />

      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/Deluxe_Room" element={<Deluxe></Deluxe>}></Route>
        <Route
          path="/Premium_Room"
          element={<PremiumSuite></PremiumSuite>}
        ></Route>
        <Route path="/Relaxation" element={<Relaxation></Relaxation>}></Route>
        <Route
          path="/SpecialOffers"
          element={<SpecialOffers></SpecialOffers>}
        ></Route>
        <Route
          path="/Restaurant"
          element={<Restaurentssingle></Restaurentssingle>}
        ></Route>
        <Route path="/Contact" element={<Contact></Contact>}></Route>
        <Route
          path="/Online_Booking"
          element={<BookingOnline></BookingOnline>}
        ></Route>
        <Route path="/Rooms" element={<AllRooms></AllRooms>}></Route>
        <Route path="/Gallery" element={<Gallery></Gallery>}></Route>
        <Route
          path="/Meeting_and_Events"
          element={<MeetingAndEvents></MeetingAndEvents>}
        ></Route>
        <Route
          path="/Swimming_Pool"
          element={<SwimmingPool></SwimmingPool>}
        ></Route>
        <Route path="/play-Ground" element={<Playzone></Playzone>}></Route>
        <Route path="/Kids-zone" element={<Kidzone></Kidzone>}></Route>
        <Route path="/Recreation" element={<Recreation></Recreation>}></Route>
        <Route path="/Facilities" element={<Facilities></Facilities>}></Route>
        <Route path="*" element={<NotFound></NotFound>}></Route>
      </Routes>
      <div>
        <div className="right-0 lg:right-10 fixed z-[300]">
          <div className="flex gap-2">
            <FloatingWhatsApp
              phoneNumber="+8801867877677"
              accountName="Support Team"
              allowEsc
              allowClickAway
              notification
              notificationSound
              avatar="https://i.ibb.co/9Z6mTm3/Matir-Maya-6x4.jpg"
              buttonStyle={{
                width: "40px",
                height: "40px",
                marginBottom: "80px",
              }}
            />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
